import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ParkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"park"}/>
}
